import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
import "leaflet/dist/leaflet.css"

// Fix Leaflet default marker icon path issue with bundlers
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
})

export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
    zoom: Number,
    listingsUrl: String,
  }

  connect() {
    this.map = L.map(this.element).setView(
      [this.latValue, this.lngValue],
      this.zoomValue
    )

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(this.map)

    this.markers = L.layerGroup().addTo(this.map)
    this.loadListings()
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
    }
  }

  async loadListings(neighborhood = "") {
    const url = new URL(this.listingsUrlValue, window.location.origin)
    if (neighborhood) {
      url.searchParams.set("neighborhood", neighborhood)
    }

    const response = await fetch(url)
    const listings = await response.json()
    this.renderMarkers(listings)
  }

  renderMarkers(listings) {
    this.markers.clearLayers()

    listings.forEach((listing) => {
      if (!listing.lat || !listing.lng) return

      const marker = L.marker([listing.lat, listing.lng])

      const popup = `
        <div class="min-w-[200px]">
          ${listing.image_url ? `<img src="${listing.image_url}" class="w-full h-32 object-cover rounded-t mb-2" />` : ""}
          <div class="px-1 pb-1">
            <p class="font-semibold text-sm">${listing.name}</p>
            <p class="text-xs text-gray-500">${listing.neighborhood || ""}</p>
            ${listing.price ? `<p class="font-semibold text-sm mt-1">${listing.price} / night</p>` : ""}
            <a href="${listing.url}" class="inline-block mt-2 text-xs font-medium text-emerald-600 hover:underline">View listing &rarr;</a>
          </div>
        </div>
      `

      marker.bindPopup(popup)
      this.markers.addLayer(marker)
    })
  }

  filterByNeighborhood(neighborhood) {
    this.loadListings(neighborhood)
  }
}
